import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "store";
import { createApplicationReferral } from "store/actions/producerManagement";
import { getIsLoggedIn } from "store/selectors";

export const useCreateApplicationReferral = () => {
  const dispatch = useAppDispatch();
  const isVerifiedUser = useAppSelector(getIsLoggedIn);
  const utmCampaign = useAppSelector(state => state.analyticsTracker.utm.utm_campaign);

  useEffect(() => {
    if (utmCampaign && isVerifiedUser) {
      dispatch(createApplicationReferral(utmCampaign));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
